<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	      <el-form-item style="width:12%">
	          <el-date-picker v-model="query.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	      </el-form-item>
	      <el-form-item style="width:12%">
	          <el-date-picker v-model="query.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	      </el-form-item>
	      <el-form-item style="width:17%">
              <el-select v-model="query.type" @change="isselect=true">
          		  <el-option v-for="(item,index) in typelists" :key="index" :label="item.name" :value="item.id"></el-option>
        	  </el-select> 
          </el-form-item>
	      <el-form-item style="width:13%" v-if="query.type==1">
              <el-select v-model="query.customer" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请选择客户" @change="isselect=true">
          		  <el-option v-for="(item,index) in customerLists" :key="index" :label="item.name" :value="item.id"></el-option>
        	  </el-select> 
          </el-form-item>
          <el-form-item style="width:11%" v-if="query.type==2">
          	  <el-select v-model="query.seller" clearable filterable placeholder="请选销售员" style="width:100%" @change="isselect=true">
				  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
			  </el-select>
		  </el-form-item>
	      <el-form-item>
	          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	      </el-form-item>
	      <!--
	      <el-form-item>
	          <template>
	          	  <div style="color:#ffd700;font-weight:bold;">收款合计：￥{{allamount}}</div>
	          </template>
	      </el-form-item>
	      -->
	  </el-form>
	  
	  <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listLoading">
	      	  <el-table-column prop="customername" label="客户名称"></el-table-column>
	      	  <el-table-column prop="amount" label="金额" width="200"></el-table-column>
	      </el-table>
	      <div class="block">
	      <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	      <!--分页end-->
	      </div>
      </div>
	  
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Stat/index",
      query: {
      	  act:'getaccounthistory',
      	  token:this.$cookies.get('token'),
      	  start:'',
      	  end:'',
      	  type:1,
      	  customer:'',
      	  seller:'',
      	  p:1,
      	  rollpage:10,
      },
      isselect:false,
      typelists:[{id:1,name:'按客户统计已收客户金额'},{id:2,name:'按销售员统计已收客户金额'}],
      customerLoading:false,
      customerLists:[],
      sellerLists:[],
      listLoading:false,
      total_rows:0,
      allamount:0.00,
      
    }
  },
  mounted(){
    this.getList();
    this.getactionauth();
    this.getSeller();
  },
  
  methods:{
  
    /** 获取操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
    /** 获取客户信息 **/
    getCustomer(query){
	    if(query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
		        }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
	    }
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                     
	        }
        }).catch((res) => {
            
        });
    },
    
    /** 获取入库信息列表 **/
    getList(){
    	if(this.isselect==true) {
    		this.query.p=1;
    		this.query.rollpage=10;
    	}
    
        this.listLoading=true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);	            
	            this.listLoading=false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.lists=result.lists;
	            this.allamount=result.allcount;
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading=false;
	            if(this.isselect==true) this.isselect=false;
	        }
        }).catch((res) => {
			this.listLoading=false;
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Accountstat.vue